export default function Logo({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-label="All-Season Crew logo"
    >
      <rect width="64" height="64" rx="16" fill="#1E4B33" />
      <path d="M32 48V30" stroke="#FBFBF8" strokeWidth="4" strokeLinecap="round" />
      <path d="M32 32c0-9 7-14 16-14 0 10-7 15-16 14z" fill="#84CC16" />
      <path d="M32 40c0-8-6-12-14-12 0 9 6 13 14 12z" fill="#65A30D" />
    </svg>
  );
}
